import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { parseHexToRGB } from "../../../../../../../../common-deprecated/utils";

export const CenterLabel = styled.button<{ hasText?: boolean }>`
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 300px;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 1;
    user-select: none;

    ${({ theme, hasText }) =>
        hasText &&
        css`
            padding: 7px 25px;
            font-size: 1.3rem;
            text-overflow: ellipsis;
            color: ${theme.color.lightest};
            white-space: nowrap;
            background-color: rgba(${parseHexToRGB(theme.color.dark).rgb}, 0.9);
            border-radius: 100px;
        `};

    svg {
        margin-right: 5px;
        color: ${({ theme }) => theme.color.lightest};
        vertical-align: middle;
    }

    @media ${getBreakpoint("up", "md")} {
        max-width: none;
    }

    html[dir="rtl"] & {
        svg {
            margin-left: 5px;
            margin-right: 0;
        }
    }
`;
